import React from 'react';
import { Clock } from 'lucide-react';
import { useFontSizes } from '../../contexts/FontSizeContext';
import { useI18n } from '../../i18n/I18nContext';
import type { WidgetProps } from './types';

export const RecentSearchesWidget: React.FC<WidgetProps> = ({
  config,
  recentSearches,
  onSearch,
  onClearRecentSearches,
}) => {
  const { heading, body, small } = useFontSizes();
  const { t } = useI18n();
  const items = config.maxItems ? recentSearches.slice(0, config.maxItems) : recentSearches;

  if (items.length === 0) return null;

  return (
    <section className="mb-4 sm:mb-8">
      <div className="flex items-center justify-between mb-2 sm:mb-4">
        <h2 className={`flex items-center gap-2 ${heading} font-semibold uppercase tracking-wider text-[#020202]`}>
          <Clock className="h-4 w-4" />
          {config.title ?? t('section.recentSearches')}
        </h2>
        <button
          type="button"
          onClick={onClearRecentSearches}
          className={`${small} text-gray-400 hover:text-brand transition-colors`}
        >
          {t('action.clear')}
        </button>
      </div>
      <div className="flex flex-wrap gap-1.5 sm:gap-2">
        {items.map((search, index) => (
          <button
            key={search}
            type="button"
            onClick={() => onSearch(search)}
            className="inline-flex items-center gap-1.5 sm:gap-2 px-3 py-1.5 sm:px-4 sm:py-2.5 bg-white border border-gray-200 rounded-full text-xs sm:text-sm text-[#020202] hover:border-brand/30 hover:text-brand hover:shadow-sm transition-all animate-fade-in"
            style={{ animationDelay: `${index * 30}ms` }}
          >
            <Clock className="h-3.5 w-3.5 text-gray-400" />
            {search}
          </button>
        ))}
      </div>
    </section>
  );
};
